import { useEffect, useRef } from 'react';
import './preferredSource.css';

export const PREFERRED_SOURCE_URL = 'https://www.google.com/preferences/source?q=taaouniaty.com';
const PUBLISHER_SCRIPT = 'https://news.google.com/swg/js/v1/publisher.js';

const COPY = {
  fr: {
    title: 'Source préférée Google',
    hint: 'Ajoutez Taaouniaty pour nous voir plus souvent dans Google, AI Overviews et Discover.',
    link: 'Ajouter Taaouniaty comme source préférée',
  },
  ar: {
    title: 'مصدر مفضّل على Google',
    hint: 'أضيفوا تعاونيتي لتظهر أكثر في Google وAI Overviews وDiscover.',
    link: 'إضافة تعاونيتي كمصدر مفضّل',
  },
  en: {
    title: 'Google preferred source',
    hint: 'Add Taaouniaty to see us more often in Google, AI Overviews and Discover.',
    link: 'Add Taaouniaty as a preferred source',
  },
};

function ensurePublisherScript() {
  if (typeof document === 'undefined') return;
  if (document.querySelector('script[data-google-preferred-source]')) return;
  const script = document.createElement('script');
  script.async = true;
  script.src = PUBLISHER_SCRIPT;
  script.setAttribute('data-google-preferred-source', 'true');
  document.head.appendChild(script);
}

export default function PreferredSourceButton({ language = 'fr', theme = 'light', compact = false }) {
  const lang = language === 'ar' ? 'ar' : language === 'en' ? 'en' : 'fr';
  const t = COPY[lang] || COPY.fr;
  const slotRef = useRef(null);

  useEffect(() => {
    const el = slotRef.current;
    if (el) {
      el.setAttribute('google-add-preferred-source-btn', '');
      el.setAttribute('data-theme', theme);
      el.setAttribute('data-lang', lang);
    }
    ensurePublisherScript();
    const queue = (window.PREFERRED_SOURCE = window.PREFERRED_SOURCE || []);
    queue.push((preferredSource) => {
      try {
        preferredSource.init({ theme, lang });
      } catch {
        /* standard DOM scan still applies */
      }
    });
  }, [theme, lang]);

  return (
    <aside className={`preferred-source${compact ? ' preferred-source--compact' : ''}`} lang={lang}>
      <p className="preferred-source__title">{t.title}</p>
      {!compact && <p className="preferred-source__hint">{t.hint}</p>}
      <div ref={slotRef} data-theme={theme} data-lang={lang} />
      <a
        className="preferred-source__link"
        href={PREFERRED_SOURCE_URL}
        target="_blank"
        rel="noopener noreferrer"
      >
        {t.link}
      </a>
    </aside>
  );
}
